module.exports = __webpack_public_path__ + "static/icons/icon-snow-report--white-0fec60601219b3d392f37183724dd0c8.svg";